import styled from 'styled-components';

export const AvailableAmount = styled.div`
  span {
    color: ${({ theme }) => theme.colors.grey.primary.standard};
  }
`;

export const AvailableAmountContainer = styled.div`
  gap: 8px;
  display: flex;
  margin-bottom: 16px;
  flex-direction: column;
`;
